export interface AttachmentUrlApiResponse {
	success?: boolean;
	statusCode?: number;
	message?: string;
	data?: string;
	url?: string;
}

export const extractAttachmentUrl = (response: unknown): string => {
	if (!response) {
		throw new Error("Empty attachment response");
	}

	if (typeof response === "string" && response.trim() !== "") {
		return response;
	}

	if (typeof response === "object" && response !== null) {
		const payload = response as AttachmentUrlApiResponse;

		if (typeof payload.data === "string" && payload.data.trim() !== "") {
			return payload.data;
		}

		if (typeof payload.url === "string" && payload.url.trim() !== "") {
			return payload.url;
		}
	}

	throw new Error("Invalid attachment URL response");
};
